import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SummaryModal = ({ open, onClose, htmlContent }) => {
  const iframeRef = useRef(null);
  const [iframeKey, setIframeKey] = useState(0);

  // Force iframe re-render when content changes
  useEffect(() => {
    if (open && htmlContent) {
      setIframeKey(prev => prev + 1);
    }
  }, [htmlContent, open]);

  useEffect(() => {
    if (!open || !iframeRef.current || !htmlContent) return;

    const iframe = iframeRef.current;

    // Delay until iframe is mounted
    const timer = setTimeout(() => {
      const doc = iframe.contentDocument || iframe.contentWindow.document;

      const rawHtml =
        typeof htmlContent === "string"
          ? htmlContent
          : typeof htmlContent === "object" && htmlContent !== null
          ? htmlContent[Object.keys(htmlContent)[0]]
          : "<div>No content available</div>";

      const wrappedHtml = `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="UTF-8" />
            <style>
              body {
                font-family: Arial, sans-serif;
                padding: 16px;
                background: #fff;
                color: #000;
              }
            </style>
          </head>
          <body>
            ${rawHtml}
          </body>
        </html>
      `;

      doc.open();
      doc.write(wrappedHtml);
      doc.close();
    }, 100); // Slight delay to ensure iframe is mounted

    return () => clearTimeout(timer);
  }, [iframeKey]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle className="flex justify-between items-center">
        Summary
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <iframe
          key={iframeKey} // force React to remount iframe
          ref={iframeRef}
          title="HTML Summary"
          style={{
            width: "100%",
            height: "70vh",
            border: "none",
            backgroundColor: "white",
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default SummaryModal;
